import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { OpsOfLawModel } from '../../models/ops-of-law.model';
import { OpsOfLawIncidentService } from '../../services/ops-of-law-incident.service';
import { IncidentTypeService } from '../../services/incident-type.service';
import { IncidentDialogContext } from '../../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../../incident-modal.component';
import { AgencyTypeService } from '../../services/agency-type.service';
import { IncidentService } from '../../services/incident.service';
import { AgencyType } from '../../../driver/models/enums/agency-type.enum';
import { PhoneNumberUSAPipe } from '../../../shared/pipes/phone-number-usa.pipe';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { ProhibitionService } from '../../../prohibition/services/prohibition.service';
import { EnumDataService } from '../../services/enums.DataService';

@Component({
    templateUrl: './ops-of-law-modal.html'
})
export class OpsOfLawModalComponent extends IncidentModalComponent<OpsOfLawModel> {
    public agencies: any[];
    private phoneNumberPipe = new PhoneNumberUSAPipe();

    constructor(
        public dialogRef: MatDialogRef<IncidentModalComponent<OpsOfLawModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<OpsOfLawModel>,
        public agencyTypeService: AgencyTypeService,
        public incidentService: IncidentService,
        public prohibitionService: ProhibitionService,
        public incidentDataService: EnumDataService,
        private service: OpsOfLawIncidentService,
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        typeService: IncidentTypeService,
        modalService: MvdModalService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);

        this.service = service;
    }

    protected onLoadLookups(callback: (error?) => void): void {
        this.agencyTypeService.getActive(this.data.incident.incidentTypeId).subscribe(r => this.onGetAgencies(r.result, callback), callback);
    }

    private onGetAgencies(result: any[], callback: (error?) => void): void {

        this.agencies = result;

        callback();
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: OpsOfLawModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;
        callback();
    }

    public phoneNumber = (): string => {
        let phone = this.phoneNumberPipe.transform(this.data && this.data.incident && this.data.incident.lienAgencyPhoneNumber || '');

        if (this.caughtChange[0] && this.caughtChange[0] > 0) {
            const agencyTypes: AgencyType = new AgencyType();
            if (agencyTypes.FromId(this.caughtChange[0])) {
                phone = this.phoneNumberPipe.transform(agencyTypes.FromId(this.caughtChange[0]).agencyPhoneNumber);
                this.data.incident.lienAgencyPhoneNumber = phone;
            }
        }

        return phone;
    };

    protected onSaveIncident(callback: (error?: any) => void): void {
        var agency = this.incidentForm.get('agencyTypeId').value;
        this.data.incident.agencyTypeId = agency.id;

        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId)
            .subscribe(_ => { }, e => this.handleError, () => {
                this.dialogRef.close(true);
            });
    }
}
